import { appointmentToAppointmentDraftComparisonSelectors } from './appointment.comparison.selectors';
import { appointmentDraftSelectors } from './appointment-draft.selectors';
import { appointmentSelectors } from './appointment.selectors';

const prepareStoreIdUpdateRequest = (state) => {
  const storeId = appointmentDraftSelectors.selectShop(state).id;
  const isStoreIdChanged =
    !appointmentToAppointmentDraftComparisonSelectors.areAppointmentStoreIdsTheSame(state);

  return isStoreIdChanged
    ? {
        storeId,
      }
    : {};
};

const preparePartnerUpdateRequest = (state) => {
  const isPartnerIdChanged =
    !appointmentToAppointmentDraftComparisonSelectors.areAppointmentPartnerIdsTheSame(state);

  const { from, eventId } = appointmentDraftSelectors.selectAppointmentTimeSlot(state);

  return isPartnerIdChanged
    ? {
        partnerId: appointmentDraftSelectors.selectPartnerId(state),
        date: appointmentDraftSelectors.selectAppointmentDateSlot(state),
        time: from,
        eventId,
      }
    : {};
};

const prepareDateSlotUpdateRequest = (state) => {
  const isDateSlotChanged =
    !appointmentToAppointmentDraftComparisonSelectors.areAppointmentDateSlotsTheSame(state);

  const { from, eventId } = appointmentDraftSelectors.selectAppointmentTimeSlot(state);

  return isDateSlotChanged
    ? {
        date: appointmentDraftSelectors.selectAppointmentDateSlot(state),
        time: from,
        eventId,
      }
    : {};
};

const prepareTimeSlotUpdateRequest = (state) => {
  const isTimeSlotChanged =
    !appointmentToAppointmentDraftComparisonSelectors.areAppointmentTimeSlotsTheSame(state);

  const { from, eventId } = appointmentDraftSelectors.selectAppointmentTimeSlot(state);

  return isTimeSlotChanged
    ? {
        time: from,
        eventId,
      }
    : {};
};

const prepareEventIdUpdateRequest = (state) => {
  const isEventIdChanged =
    !appointmentToAppointmentDraftComparisonSelectors.areAppointmentEventIdsTheSame(state);

  const eventId = appointmentDraftSelectors.selectAppointmentEventId(state);

  return isEventIdChanged
    ? {
        eventId,
      }
    : {};
};

const prepareRelatedAppointmentsUpdateRequest = (state) => {
  const relatedAppointments = appointmentSelectors.selectRelatedAppointments(state);
  const addons = appointmentDraftSelectors.selectRelatedAppointmentDrafts(state);

  return addons
    .map((addon) => {
      const relatedAppointment = relatedAppointments.find(
        (el) => el.appointmentType.id === addon.appointmentType.localId,
      );

      return relatedAppointment
        ? {
            time: addon.timeSlot.from !== relatedAppointment.time ? addon.timeSlot.from : null,
            eventId:
              addon.timeSlot.from !== relatedAppointment.time ? addon.timeSlot.eventId : null,
          }
        : null;
    })
    .filter(Boolean);
};

const prepareAddressUpdateRequest = (state) => {
  const isAddressesChanged =
    !appointmentToAppointmentDraftComparisonSelectors.areAddressesTheSame(state);

  return isAddressesChanged
    ? {
        address: appointmentDraftSelectors.selectDraftAddress(state),
      }
    : {};
};

const prepareProductsUpdateRequest = (state) => {
  const areProductsTheSame =
    !appointmentToAppointmentDraftComparisonSelectors.areProductsTheSame(state);

  return areProductsTheSame
    ? {
        products: appointmentDraftSelectors.selectProducts(state).map((product) => ({
          id: product.id,
          information: product.information,
          quantity: product.quantity,
          selectionTypeId: product.selectionType?.id,
        })),
      }
    : {};
};

const prepareUpdateAppointmentRequest = (state, updateRequest) => {
  // ignoring updateRelatedAppointment since prepareRelatedAppointmentsUpdateRequest is responsible for this
  const { relatedAppointments, ...restUpdateRequest } = updateRequest;

  return {
    ...prepareStoreIdUpdateRequest(state),
    ...prepareDateSlotUpdateRequest(state),
    ...prepareTimeSlotUpdateRequest(state),
    ...preparePartnerUpdateRequest(state),
    ...prepareEventIdUpdateRequest(state),
    ...prepareAddressUpdateRequest(state),
    ...prepareProductsUpdateRequest(state),
    relatedAppointmentRequests: prepareRelatedAppointmentsUpdateRequest(state),
    ...restUpdateRequest,
  };
};

export const appointmentRequestHelpers = {
  prepareStoreIdUpdateRequest,
  preparePartnerUpdateRequest,
  prepareDateSlotUpdateRequest,
  prepareTimeSlotUpdateRequest,
  prepareEventIdUpdateRequest,
  prepareRelatedAppointmentsUpdateRequest,
  prepareAddressUpdateRequest,
  prepareProductsUpdateRequest,
  prepareUpdateAppointmentRequest,
};
